import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function NextIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 17 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3431 0.928635L16.7071 7.2926C17.0976 7.68312 17.0976 8.31629 16.7071 8.70681L10.3431 15.0708C9.95262 15.4613 9.31946 15.4613 8.92893 15.0708C8.53841 14.6802 8.53841 14.0471 8.92893 13.6566L13.5858 8.9997H1C0.447715 8.9997 0 8.55199 0 7.9997C0 7.44742 0.447716 6.9997 1 6.9997H13.5858L8.92893 2.34285C8.53841 1.95232 8.53841 1.31916 8.92893 0.928635C9.31946 0.538111 9.95262 0.538111 10.3431 0.928635Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
